import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M8 1a7 7 0 100 14A7 7 0 008 1zM4 5.125s.474.839 1.25.844H7V7c0 .556-.667 1-1.5 1S4 7.556 4 7zm8 0V7c0 .556-.667 1-1.5 1S9 7.556 9 7V5.969h1.719C11.495 5.964 12 5.125 12 5.125zM8.031 9c3.256 0 3 .384 3 .762v.266H5V9.74C5 9.39 4.775 9 8.031 9z" fill="#474747" /></svg>;
}

export default SvgComponent;